<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="elevation-1">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.native="handleModal">
                    <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <v-toolbar-title>Estado de cuenta general</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <SingleCalendar refElement="startDate" title="Fecha inicio" :input-date.sync="startDate" />
                    </v-col>
                    <v-col cols="6">
                        <SingleCalendar refElement="endDate" title="Fecha fin" :input-date.sync="endDate"
                            :min-date="startDate" />
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <v-autocomplete :items="sucursales" item-text="nombre" item-value="id" v-model="sucursalId"
                            label="Sucursales" required outlined dense hide-details="auto" prepend-inner-icon="fas fa-id-card-alt"
                            :readonly="!isAdmin" hint="Seleccione la sucursal. Este campo es opcional" clearable>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <ValidationProvider rules="required" v-slot="{ errors, valid }" :immediate="true">
                            <v-autocomplete :items="clients" item-text="nombreComercial" item-value="idCliente" v-model="clientId"
                                label="Clientes" required outlined dense hide-details="auto" prepend-inner-icon="fas fa-user-alt"
                                :readonly="!isAdmin" hint="Seleccione un cliente. Este campo es requerido" clearable
                                :error-messages="errors" :success="valid">
                            </v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <v-checkbox v-model="isLedger" persistent-hint
                        hint="Muestra el saldo del cliente antes y despues de cada pago, en vez del estado actual"
                        label="Estado de cuenta historico (saldo antes/despues de cada pago)">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" class="py-1" v-if="isLedger">
                        <v-checkbox v-model="resumen" persistent-hint
                        hint="Oculta el detalle de notas aplicadas por pago, solo muestra el listado de pagos"
                        label="Solo resumen (sin detalle de notas aplicadas)">
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-4" dark class="btn text-white" @click.prevent="previewPDF"
                :loading="loading" :disabled="clientId == null">
                  <v-icon left>fas fa-file-pdf</v-icon>
                  {{ loading ? 'Generando PDF' : 'Ver PDF' }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob"
      :title-pdf="isLedger ? 'ESTADO DE CUENTA HISTORICO' : 'REPORTE DE ESTADO DE CUENTA GENERAL'" :handlePdfModal="handlePdfModal"
      :dialog="showPdf" v-if="showPdf">
    </PreviewPDF>
    </v-dialog>
</template>

<script>
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import SingleCalendar from '@/components/shared/SingleCalendar.vue';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import VentaDataService from '@/service/venta/VentaDataService';
import VentaPagoDataService from '@/service/venta/pago/VentaPagoDataService';
import { getDateLocaleNatural } from '@/utils/DateUtil';
import { extractMessage } from '@/helpers/errorHelper';

export default {
  name: 'ExportAccountStatement',
  props: {
    dialog: { type: Boolean, default: false },
    handleModal: { type: Function },
    sucursales: { type: Array },
    clients: { type: Array },
    isAdmin: { type: Boolean, default: false }
  },
  components: { SingleCalendar, PreviewPDF },
  data() {
    return {
      startDate: '',
      endDate: '',
      sucursalId: SucursalDataService.getCurrentSucursalId(),
      clientId: null,
      isLedger: false,
      resumen: false,
      // to PDF
      pdfBlob: '',
      pdfSource: null,
      showPdf: false,
      loading: false
    }
  },
  methods: {
    previewPDF() {
      if ( !this.clientId ) {
        this.$swal.fire({ icon: 'info', title: 'Reporte de estado de cuenta', text: 'Seleccione un cliente', showConfirmButton: false, timer: 2500 });
        return
      }
      const startDate = getDateLocaleNatural(this.startDate) ?? '';
      const endDate = getDateLocaleNatural(this.endDate) ?? '';
      const brandName = this.sucursales.find(brand => brand.id === this.sucursalId)?.nombre ?? '';
      const params = { startDate, endDate, sucursalId: this.sucursalId, clientId: this.clientId ?? 0,
        resumen: this.isLedger ? this.resumen : undefined };
      const request = this.isLedger
        ? VentaPagoDataService.printAccountStatementLedger(params)
        : VentaDataService.printAccountStatement(params);
      this.loading = true
      request.then( response => {
        if(response.status == 204) {
          this.$swal.fire({ icon: 'info', title: 'Reporte de estado de cuenta', text: 'No hay registros para visualizar', showConfirmButton: false, timer: 2500 });
          return
        }
        this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
        this.pdfSource = URL.createObjectURL(this.pdfBlob)
        this.showPdf = true
      }).catch( error => {
        this.$swal.fire({ position: 'top-end', icon: 'error', text: 'Error al generar el reporte: ' + extractMessage(error), showConfirmButton: false, timer: 3500 });
      }).finally(() => this.loading = false)
    },
    handlePdfModal(){
      this.showPdf = !this.showPdf
      this.cleanupPdf()
    },
    cleanupPdf(){
      if(this.pdfSource){
        URL.revokeObjectURL(this.pdfSource)
        this.pdfSource = null
      }
      this.pdfBlob = null
    }
  }
}
</script>